import React from "react";
import { FormattedMessage } from "react-intl";

import ElemIndicatorSVG from "@components/icons/elem-indicator-svg";

import { strokeDashoffset } from "@helpers/helpers";
import { ILesson } from "@typings/global.types";

type PropsType = {
  lesson: ILesson;
  index: number;
};

function ItemLesson({ lesson, index }: PropsType) {
  return (
    <div className='item-lesson'>
      <div>
        <FormattedMessage id='lesson' /> {index + 1}
        <br />
        <b>{lesson.name}</b>
      </div>
      <div className='ml-4 flex'>
        <ElemIndicatorSVG
          d='M36.5416 23.0555L39.0657 29.3114C39.2936 29.8777 39.8321 30.2634 40.4461 30.3036L47.2491 30.7409C48.6903 30.8341 49.2782 32.6192 48.1678 33.5312L42.9237 37.8356C42.4491 38.2241 42.2444 38.8493 42.3968 39.4386L44.0762 45.9669C44.4332 47.3477 42.8961 48.4517 41.6754 47.6904L35.9102 44.0943C35.3892 43.7674 34.7244 43.7674 34.2048 44.0943L28.4396 47.6904C27.2174 48.4517 25.6818 47.3477 26.0374 45.9669L27.7182 39.4386C27.8691 38.8493 27.6659 38.2241 27.1913 37.8356L21.9472 33.5312C20.8368 32.6192 21.4232 30.8341 22.8645 30.7409L29.669 30.3036C30.2829 30.2634 30.8214 29.8777 31.0493 29.3114L33.5719 23.0555C34.1075 21.7292 36.0075 21.7292 36.5416 23.0555Z'
          colorPathCircle={
            strokeDashoffset(
              lesson.exercises.length,
              lesson.exercisesWithStarCount,
            ) === 150
              ? "stroke-gray dark:stroke-gray-dark-default"
              : "stroke-green dark:stroke-green-dark-default"
          }
          classNameProps='h-[52px] w-auto md:h-[70px]'
          strokeDashoffset={strokeDashoffset(
            lesson.exercises.length,
            lesson.exercisesWithStarCount,
          )}
        />
        <ElemIndicatorSVG
          d='M34.9992 31.2801C32.9484 31.2801 31.2785 32.9485 31.2785 35.0008C31.2785 37.0501 32.9484 38.72 34.9992 38.72C37.0515 38.72 38.7199 37.0501 38.7199 35.0008C38.7199 32.9485 37.0515 31.2801 34.9992 31.2801ZM34.9993 42.646C30.7839 42.646 27.3526 39.2162 27.3526 35.0008C27.3526 30.784 30.7839 27.3542 34.9993 27.3542C39.2146 27.3542 42.6474 30.784 42.6474 35.0008C42.6474 39.2162 39.2146 42.646 34.9993 42.646ZM34.9992 22.5555C28.1381 22.5555 22.5555 28.1381 22.5555 35.0007C22.5555 41.8619 28.1381 47.4444 34.9992 47.4444C41.8604 47.4444 47.4444 41.8619 47.4444 35.0007C47.4444 28.1381 41.8604 22.5555 34.9992 22.5555Z'
          colorPathCircle={
            strokeDashoffset(
              lesson.exercises.length,
              lesson.exercisesWithStarCount,
            ) === 150
              ? "stroke-gray dark:stroke-gray-dark-default"
              : "stroke-orange dark:stroke-orange-dark-default"
          }
          classNameProps='h-[52px] w-auto md:h-[70px]'
          strokeDashoffset={strokeDashoffset(
            lesson.exercises.length,
            lesson.exercisesWithTargetCount,
          )}
        />
        <ElemIndicatorSVG
          d='M36.0403 21.5005L27.1372 31.3087C26.072 32.4859 26.4534 34.4599 27.8654 35.0718L33.2704 37.4111L30.8599 46.5323C30.4132 48.2191 32.3939 49.3827 33.4535 48.0582L42.5841 36.6413C43.5272 35.4612 43.1416 33.6285 41.8198 33.0091L36.1665 30.3646L38.5396 23.2024C39.0861 21.5486 37.1762 20.2467 36.0403 21.5005Z'
          colorPathCircle={
            strokeDashoffset(
              lesson.exercises.length,
              lesson.exercisesWithStarCount,
            ) === 150
              ? "stroke-gray dark:stroke-gray-dark-default"
              : "stroke-purple dark:stroke-purple-dark-default"
          }
          classNameProps='h-[52px] w-auto md:h-[70px]'
          strokeDashoffset={strokeDashoffset(
            lesson.exercises.length,
            lesson.exercisesWithLightningCount,
          )}
        />
      </div>
    </div>
  );
}

export default ItemLesson;
